<template>
  <!-- display card if  apprenticeships exist-->
  <v-card flat class="pb-8">
    <v-card v-if="showList" class="v-card__container" flat>
      <!-- display all apprenticeships in table component -->
      <v-data-table
        :headers="[
          {text: 'Namn', value: 'firstName'},
          {text: 'Personnummer', value: 'personalNumber'},
          {text: 'Yrke', value: 'professionId'},
          {text: 'Mobiltelefon', value: 'mobilephone'},
          {text: 'Start', value: 'fromDate'},
          {text: 'Slut', value: 'toDate'},
          {text: 'Bortkopplad', value: 'manuallyEndedDate'},
          {text: selectedCompany.hasDepartments ? 'Arbetsplatser (Avd.)' : 'Arbetsplatser', value: 'workplaces'},
          {text: 'Handledare', value: 'instructors'},
          {text: 'Visa', value: 'action', align: 'center'}
        ]"
        :items="apprenticeshipsList"
        item-key="id"
        class="mt-6 clickable"
        :item-class="setRowLineThrough"
      >
        <!-- ,
          {text: 'Visa/ändra', value: 'action', sortable: false} -->
        <template slot="item.firstName" slot-scope="props">
          <div style="width: 150px">
            <router-link :to="'/people/' + props.item.apprenticeId"
              >{{ props.item.firstName }} {{ props.item.lastName }}</router-link
            >
          </div>
        </template>
        <!-- display Profession names in  -->
        <template slot="item.professionId" slot-scope="props">
          <div>{{ getProfessionNameById(props.item.professionId) }}</div>
        </template>

        <template slot="item.personalNumber" slot-scope="props">
          <div style="width: 140px">{{ props.item.personalNumber }}</div>
        </template>

        <!-- display workplaces name  -->
        <template slot="item.workplaces" slot-scope="props">
          <div style="width: 260px">
            {{
              selectedCompany.hasDepartments
                ? separateByCommaWorkplaces(props.item.workplaces)
                  ? separateByCommaWorkplaces(props.item.workplaces)
                  : ''
                : separateByCommaWorkplaces(props.item.workplaces).replace('()', '')
            }}
          </div>
        </template>
        <!-- display employed full name  -->
        <template slot="item.instructors" slot-scope="props">
          <div style="width: 260px">
            {{
              separateByCommaInstructors(props.item.instructors)
                ? separateByCommaInstructors(props.item.instructors)
                : ''
            }}
          </div>
        </template>

        <template slot="item.mobilephone" slot-scope="props">
          <div style="width: 130px">{{ props.item.mobilephone }}</div>
        </template>

        <!-- display full start date  -->
        <template slot="item.fromDate" slot-scope="props">
          <div style="width: 100px">{{ props.item.fromDate | date }}</div>
        </template>

        <!-- display full to date  -->
        <template slot="item.toDate" slot-scope="props">
          <div style="width: 100px">{{ props.item.toDate | date }}</div>
        </template>

        <!-- display disconnected apprenticeship  -->
        <template slot="item.manuallyEndedDate" slot-scope="props">
          <div style="width: 160px" class="d-flex justify-center">
            <v-checkbox disabled v-model="props.item.manuallyEndedDate"></v-checkbox>
          </div>
        </template>

        <template slot="item.action" slot-scope="props">
          <div class="d-flex justify-center" style="width: 100px">
            <v-icon
              class="clickable"
              @click="
                apprenticeship = props.item
                showList = false
                showCreateOrEdit = false
                showView = true
              "
              >$sl-view-on</v-icon
            >
            <v-icon
              class="ml-2 clickable"
              :disabled="!canUpdate"
              @click="
                apprenticeship = props.item
                unlinkApprenticenship = true
                showList = false
                showCreateOrEdit = false
                showView = true
              "
            >
              $sl-edit</v-icon
            >
          </div>
        </template>
      </v-data-table>
      <v-btn 
        data-cy="create-employee"
        absolute
        bottom
        right
        fab
        :disabled="!canCreate"
        @click="
          showList = true
          showCreateOrEdit = true
          showView = false
        "
      >
        <v-icon class="ml-1">$sl-add</v-icon>
      </v-btn>
    </v-card>

    <v-dialog v-model="showCreateOrEdit" max-width="600px">
      <CreateApprenticeship
      :allDepartments="allDepartments"
      :apprenticeshipsList="apprenticeshipsList"
      v-if="showCreateOrEdit"
        @back-to-list="
          showList = true
          showCreateOrEdit = false
          showView = false
          unlinkApprenticenship = false
          getApprenticeships()
        "
        @close="
          showList = true
          showCreateOrEdit = false
          showView = false
        "
      />
    </v-dialog>
    <div v-if="showView">
      <ApprenticenshipShow
        :apprenticeshipId="apprenticeship.id"
        :unlinkApprenticenship="unlinkApprenticenship"
        @back-to-list="
          showList = true
          showCreateOrEdit = false
          showView = false
          unlinkApprenticenship = false
          getApprenticeships()
        "
      />
    </div>
  </v-card>
</template>

<script>
import API from '@/services/api.js'
import CreateApprenticeship from '@/components/company/apprenticenship/CreateApprenticeship'
import ApprenticenshipShow from '@/components/company/apprenticenship/ApprenticenshipShow'
import {CanIDo} from '@/components/mixins'
import {mapGetters, mapActions} from 'vuex'
import get from 'lodash/get'
// @group Company
// Styled CompanyApprenticenships component
export default {
  name: 'CompanyApprenticenships',

  mixins: [CanIDo],
  
  props: {
    allDepartments: {
      type: Array,
      default: () => ([])
    }
  },

  data() {
    return {
      apprenticeshipsList: [],
      apprenticeship: {},
      instructors: [],
      professions: [],
      unlinkApprenticenship: false,
      showList: true,
      showCreateOrEdit: false,
      showView: false
    }
  },
  components: {
    CreateApprenticeship,
    ApprenticenshipShow
  },
  watch: {
    reRender(newValue, oldValue) {
      this.getApprenticeships()
    }
  },
  /**
   * @vuese
   * Used call apprenticeships func, getProfessions func and get getEmployes func
   *  @arg  call the functions with no arguments
   */
  created() {
    this.getApprenticeships()
  },

  computed: {
    ...mapGetters('app', ['isLoading']),
    ...mapGetters('company', ['selectedCompany']),
    ...mapGetters('basic', ['getProfessionNameById'])
  },

  asyncComputed: {
    canCreate(){
      return this.canIDo('apprentice', 'create');
    },
    canUpdate(){
      return this.canIDo('apprentice', 'update');
    }
  },

  methods: {
    ...mapActions('app', ['set_loading']),

    setRowLineThrough(item) {
      const isDisconnected = this.apprenticeshipsList?.find(apprenticeship => {
        return apprenticeship.id === item.id && item.manuallyEndedDate
      })

      return isDisconnected ? 'text-decoration-line-through' : ''
    },

    monthDiff(d1, d2) {
      var months
      months = (d2.getFullYear() - d1.getFullYear()) * 12
      months -= d1.getMonth()
      months += d2.getMonth()
      return months <= 0 ? 0 : months
    },

    // @vuese
    //- Used to get all the  apprenticeships from the selected company and display data in table
    getApprenticeships() {
      API.listCompanyApprenticenships(this.selectedCompany.id)
        .then(response => {
          let arr = []
          response.data.forEach(el => {
            if(!Boolean(el.manuallyEndedDate && this.monthDiff(new Date(), new Date(el.manuallyEndedDate)) >= 2)) {
              arr.push({
                id: el.id,
                instructors: el.instructors ? el.instructors : [],
                workplaces: el.workplaces ? el.workplaces : [],
                professionId: el.professionId,
                fromDate: el.fromDate,
                toDate: el.toDate,
                manuallyEndedDate: el.manuallyEndedDate,
                firstName: el.apprentice.firstName,
                apprenticeId: el.apprentice.id,
                lastName: el.apprentice.lastName,
                personalNumber: el.apprentice.personalNumber,
                mobilephone: el.apprentice.mobilephone
              })
            }
          })
          this.apprenticeshipsList = arr
        })
        .catch(error => {
          console.log('get listCompanyApprenticenships', error.response)
        })
    },
    separateByCommaInstructors(instructors) {
      return instructors
        .map(i => {
          return get(i, 'employed.firstName', '') + ' ' + get(i, 'employed.lastName', '')
        })
        .join(', ')
    },
    separateByCommaWorkplaces(workplaces) {
      const hasDepartments = this.selectedCompany.hasDepartments
      const workplacesList = workplaces
        .map(w => {
          return (
            get(w, 'workplaceaddress.name', '') +
            ' (' +
            get(w, 'workplaceaddress.departmentWorkplaces', [])
              .map(d => {
                return get(d, 'department.name', '')
              })
              .join(', ') +
            ')'
          )
        })
        .join(', ')
      return workplacesList || ''
    }
  }
}
</script>

<style scoped></style>
